import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function FinalCta() {
  return <section className="w-full border-t border-zinc-800 bg-zinc-900 py-16 text-center lg:py-20" data-id="element-39" data-mp="vghi7rluohq2">
      <div className="mx-auto max-w-2xl px-6" data-id="element-40" data-mp="19fqmbsws7ldo">
        <h2 className="font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-41" data-mp="19cmdujcaa3h7">
          Tu próxima clase puede tener un método
        </h2>
        <p className="mt-4 text-base leading-relaxed text-zinc-300" data-id="element-42" data-mp="1jbtx1n5p8sc8">
          Acceso inmediato, 7 días de garantía y los 5 bonos incluidos.
        </p>
        <div className="mt-8 flex flex-col items-center gap-3" data-id="element-43" data-mp="1t2omf0e8s81w">
          <CtaButton origin="cierre-final" data-id="element-44" data-mp="1t250z9pdv1j4">Quiero el pack Boxeo 360 ahora</CtaButton>
          <Countdown data-id="element-45" data-mp="1o4ddcrvru1kq" />
        </div>
      </div>
    </section>;
}